import {
  EmployeeWithReportedPayrollViewModel,
  PayrollHistoryViewModel,
  ReportingPeriodViewModel,
} from '@fora-monorepo/employer-my-pages-common/types';

import { mockEmploymentsLargeAmount } from './mockPayHistoryLargeAmount';

export const mockPayHistory: PayrollHistoryViewModel = {
  tooManyRecords: false,
  reportedPayrolls: [
    {
      attributablePay: null,
      employeeId: '197903309230',
      firstName: 'Sven',
      lastName: 'Testsson',
      organizationName: 'HÄLLS MÅLERI AB',
      organizationNumber: '5566383906',
      partnerNumberIndividual: '7000004131',
      partnerNumberOrganization: '0030023349',
      payAmount: 8000,
      payMonth: '2024-06',
    },
    {
      attributablePay: null,
      employeeId: '198804209230',
      firstName: 'Klara',
      lastName: 'Jansson',
      organizationName: 'HÄLLS MÅLERI AB',
      organizationNumber: '5566383906',
      partnerNumberIndividual: '7000004132',
      partnerNumberOrganization: '0030023349',
      payAmount: 20000,
      payMonth: '2024-06',
    },
    {
      attributablePay: null,
      employeeId: '197903309230',
      firstName: 'Test',
      lastName: 'Testsson',
      organizationName: 'HÄLLS MÅLERI AB',
      organizationNumber: '5566383906',
      partnerNumberIndividual: '7000004133',
      partnerNumberOrganization: '0030023349',
      payAmount: 100000,
      payMonth: '2024-06',
    },
    {
      attributablePay: null,
      employeeId: '197903309230',
      firstName: 'Test',
      lastName: 'Testsson',
      organizationName: 'HÄLLS MÅLERI AB',
      organizationNumber: '5566383906',
      partnerNumberIndividual: '7000004131',
      partnerNumberOrganization: '0030023349',
      payAmount: 4500,
      payMonth: '2024-07',
    },
    {
      attributablePay: null,
      employeeId: '197903309230',
      firstName: 'Karl',
      lastName: 'Karlsson',
      organizationName: 'HÄLLS MÅLERI AB',
      organizationNumber: '5566383906',
      partnerNumberIndividual: '7000004131',
      partnerNumberOrganization: '0030023349',
      payAmount: 67000,
      payMonth: '2024-08',
    },
  ],
};

export const mockReportingPeriods: ReportingPeriodViewModel[] = [
  {
    payMonth: '202401',
    periodFromDate: '20240101',
    periodToDate: '20240131',
    periodDueDate: '20240225',
    isPeriodOpen: false,
    isPeriodDue: false,
  },
  {
    payMonth: '202402',
    periodFromDate: '20240201',
    periodToDate: '20240229',
    periodDueDate: '20240225',
    isPeriodOpen: false,
    isPeriodDue: false,
  },
  {
    payMonth: '202403',
    periodFromDate: '20240301',
    periodToDate: '20240331',
    periodDueDate: '20240425',
    isPeriodOpen: false,
    isPeriodDue: false,
  },
  {
    payMonth: '202404',
    periodFromDate: '20240401',
    periodToDate: '20240431',
    periodDueDate: '20240525',
    isPeriodOpen: false,
    isPeriodDue: false,
  },
  {
    payMonth: '202405',
    periodFromDate: '20240501',
    periodToDate: '20240530',
    periodDueDate: '20240625',
    isPeriodOpen: false,
    isPeriodDue: false,
  },
  {
    payMonth: '202406',
    periodFromDate: '20240601',
    periodToDate: '20240631',
    periodDueDate: '20240725',
    isPeriodOpen: false,
    isPeriodDue: true,
  },
];

const standard: EmployeeWithReportedPayrollViewModel[] = [
  {
    partnerNumberIndividual: '7000004131',
    employeeId: '195503071796',
    firstName: 'Sven',
    lastName: 'Testsson',
  },
  {
    partnerNumberIndividual: '7000004132',
    employeeId: '194501103297',
    firstName: 'Klara',
    lastName: 'Jansson',
  },
  {
    partnerNumberIndividual: '700000071',
    employeeId: '199501312384',
    firstName: 'Testcordination number',
    lastName: 'MVP',
  },
  {
    partnerNumberIndividual: '7000004133',
    employeeId: '195710142653',
    firstName: 'Test',
    lastName: 'Testsson',
  },
];

export const mockEmployeesWithReportedPayroll = {
  standard,
  largeAmount: mockEmploymentsLargeAmount
}
